<template>
  <el-dialog
    :visible.sync="visible"
    width="555px"
    custom-class="fifl-dialog"
    :close-on-click-modal="false"
    top="20px"
  />
</template>

<script>
export default {
	name: "FormDialog",
	props: ["isDialogVisible"],
	data() {
		return {
			visible: false,
		};
	},
	computed: {},
	watch: {
		isDialogVisible(value) {
			this.visible = value;
		},
		visible(value) {
			this.$emit("update:isDialogVisible", value);

			if (!value) {
				this.initFormData();
			}
		},
	},
	methods: {
		initFormData() {
			return;
		},
		openDialog() {
			this.visible = true;
		},
		closeDialog() {
			this.visible = false;
		},
	},
};
</script>

<style lang="scss">
</style>
